var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('img',{attrs:{"src":require("../assets/images/err_icon.png"),"alt":""}}),_c('p',[_vm._v("抱歉,您暂无权限登录该系统！ ")])])
}]

export { render, staticRenderFns }